// extracted by mini-css-extract-plugin
module.exports = {"popup":"joinPopup_popup__3JUUQ","title":"joinPopup_title__2Zhmc","content":"joinPopup_content__C4fuT"};